import {TFunction} from '@wix/yoshi-flow-editor'
import {State} from '../types'

export const getEventsMembersPageTitle = (state: State, t: TFunction) =>
  state.eventsMembersPage?.name ?? t('eventsMembersPageName')
